import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["tabPosition", "children", "tabBarStyle", "className", "type", "destroyInactiveTabPane"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Tabs } from 'antd';
import _values from 'lodash/values';
import colors from 'tstyles/variables.scss';
import TabBody from './TabBody';
import { TAB_TYPE, TAB_TYPE_VS_ANTD_PROPS } from './tabs.constants';
import './tabs.scss';
var TAB_TYPE_VS_DEFAULT_TAB_BAR_STYLE = _defineProperty({}, TAB_TYPE.LINE_VARIANT_GENERAL, {
  background: colors.glitter
});
var TabsAnt = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TabsAnt, _React$PureComponent);
  var _super = _createSuper(TabsAnt);
  function TabsAnt() {
    _classCallCheck(this, TabsAnt);
    return _super.apply(this, arguments);
  }
  _createClass(TabsAnt, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        tabPosition = _this$props.tabPosition,
        children = _this$props.children,
        tabBarStyle = _this$props.tabBarStyle,
        className = _this$props.className,
        type = _this$props.type,
        destroyInactiveTabPane = _this$props.destroyInactiveTabPane,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var _ref = TAB_TYPE_VS_ANTD_PROPS[type] || TAB_TYPE_VS_ANTD_PROPS.LINE_VARIANT_GENERAL,
        antdTabType = _ref.type,
        tabVariantClassName = _ref.className;
      return /*#__PURE__*/React.createElement(Tabs, _extends({
        tabPosition: tabPosition,
        tabBarStyle: tabBarStyle || TAB_TYPE_VS_DEFAULT_TAB_BAR_STYLE[type],
        className: cx(className, tabVariantClassName),
        type: antdTabType,
        destroyInactiveTabPane: destroyInactiveTabPane
      }, rest), children);
    }
  }]);
  return TabsAnt;
}(React.PureComponent);
_defineProperty(TabsAnt, "propTypes", {
  tabPosition: PropTypes.string,
  tabBarStyle: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.oneOf(_values(TAB_TYPE)),
  destroyInactiveTabPane: PropTypes.bool
});
_defineProperty(TabsAnt, "defaultProps", {
  tabPosition: 'top',
  tabBarStyle: null,
  className: null,
  children: null,
  type: TAB_TYPE.LINE_VARIANT_GENERAL,
  destroyInactiveTabPane: false
});
_defineProperty(TabsAnt, "TabPane", Tabs.TabPane);
_defineProperty(TabsAnt, "TabBody", TabBody);
_defineProperty(TabsAnt, "TAB_TYPE", TAB_TYPE);
export default TabsAnt;